import React, { useState, useEffect } from "react";
import { Button, Form, Container, Alert, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import myorders from "./img/myorders.jpg";
import specialbanner from "./img/specialofferbanner.jpg";
import missionimage from "./img/missionofyaasaai.jpeg";
import { motion } from "framer-motion";
import "./css/login.css";
import WelcomeBannerWithVideo from "./WelcomeBannerWithVideo";
import { analytics, logEvent } from "../firebase";

function LoginPage({ onLoginSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSessionId, setOtpSessionId] = useState("");

  const [showPopup, setShowPopup] = useState(true);
  const [showReturnPolicy, setShowReturnPolicy] = useState(false); // 🚀 New state for modal
  const [showTermsPolicy, setShowTermsPolicy] = useState(false);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  {
    /*otp auto handle */
  }

  useEffect(() => {
    window.addEventListener("message", handleOtpMessage);
    return () => window.removeEventListener("message", handleOtpMessage);
  }, []);

  const handleOtpMessage = (event) => {
    if (event.data?.type === "OTP_RECEIVED") {
      const otp = event.data.otp;
      setOtp(otp); // Auto-fill the OTP input
      handleVerifyOtp(otp); // Optionally verify OTP directly
    }
  };

  const handleGuestLogin = async () => {
    // Set demo user session
    localStorage.setItem("userEmail", "9252532452");
    localStorage.setItem("userPhoneNumber", "9252532452");
    onLoginSuccess("OTP_TOKEN_PLACEHOLDER", "9252532452");
    // Redirect to homepage or dashboard
    // navigate("/home"); // or whatever route you're using
  };

  useEffect(() => {
    const popupShown = localStorage.getItem("popupShown");
    if (!popupShown) {
      setShowPopup(true);
      localStorage.setItem("popupShown", "true");
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        "https://yaasaai.com/myphpapi/login.php",
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.token) {
        const { token, phonenumber } = response.data;
        console.log("Login Successful:", { token, phonenumber });
        onLoginSuccess(token, phonenumber);
      } else {
        setError(response.data.message || "Invalid credentials. Try again.");
      }
    } catch (err) {
      setError("Login failed. Please check your mobile number and password.");
    } finally {
      setLoading(false);
    }
  };

  const handleSendOtp = async () => {
    try {
      const response = await axios.post(
        "https://yaasaai.com/myphpapi/send_otp.php",
        {
          phone: email,
        }
      );
      if (response.data.Status === "Success") {
        setOtpSessionId(response.data.Details);
        setOtpSent(true);
      } else {
        setError("Failed to send OTP.");
      }
    } catch (err) {
      setError("Error sending OTP.");
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://yaasaai.com/myphpapi/verify_otp.php",
        {
          sessionId: otpSessionId,
          otp: otp,
        }
      );

      if (response.data.Status === "Success") {
        // Register or login
        await axios.post(
          "https://yaasaai.com/myphpapi/check_or_register_phone.php",
          {
            phone: email,
          }
        );

        localStorage.setItem("userEmail", email);
        localStorage.setItem("userPhoneNumber", email);
        onLoginSuccess("OTP_TOKEN_PLACEHOLDER", email);
      } else {
        setError("Invalid OTP.");
      }
    } catch (err) {
      setError("Error verifying OTP.");
    }
  };
  return (
    <div
      style={{
        backgroundImage: `url(${myorders})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        paddingTop: "40px",
      }}
    >
      {/* ✅ Popup Modal */}
      {showPopup && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ position: "relative", textAlign: "center" }}>
            {/* <img
              src={specialbanner}
              alt="Welcome"
              style={{
                maxWidth: "90vw",
                maxHeight: "80vh",
                borderRadius: "20px",
                boxShadow: "0 0 20px rgba(0,0,0,0.3)",
              }}
            /> */}
            <WelcomeBannerWithVideo />

            <div
              style={{
                position: "absolute",
                bottom: "-50px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 10000,
              }}
            >
              {/*   <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#ff4d4f",
                  color: "#fff",
                  padding: "12px 24px",
                  borderRadius: "30px",
                  textDecoration: "none",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                  transition: "all 0.3s ease",
                }}
              >
                🛒 Order Now
              </a> */}
            </div>
            <Button
              variant="danger"
              onClick={() => setShowPopup(false)}
              style={{
                position: "absolute",
                top: "-10px",
                right: "-10px",
                borderRadius: "50%",
                padding: "5px 10px",
                fontWeight: "bold",
              }}
            >
              ✕
            </Button>
          </div>
        </motion.div>
      )}

      {/* 🎀 Ribbons and Stars */}
      <motion.div
        className="ribbon"
        initial={{ x: -100, y: -100, rotate: 0 }}
        animate={{ x: 0, y: 0, rotate: [0, 10, -10, 0] }}
        transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "150px",
          height: "150px",
          backgroundColor: "red",
          clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 80%)",
          opacity: 0.8,
        }}
      />
      <motion.div
        className="ribbon"
        initial={{ x: 100, y: 100, rotate: 0 }}
        animate={{ x: 0, y: 0, rotate: [0, -10, 10, 0] }}
        transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
        style={{
          position: "absolute",
          bottom: "0",
          right: "0",
          width: "150px",
          height: "150px",
          backgroundColor: "gold",
          clipPath: "polygon(0 20%, 100% 0, 100% 100%, 20% 80%)",
          opacity: 0.8,
        }}
      />
      {["top-left", "top-right", "bottom-left", "bottom-right"].map(
        (pos, index) => (
          <motion.div
            key={index}
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            style={{
              position: "absolute",
              [pos.includes("top") ? "top" : "bottom"]: "10px",
              [pos.includes("left") ? "left" : "right"]: "10px",
              fontSize: "30px",
            }}
          >
            🌟
          </motion.div>
        )
      )}

      {/* 📝 Login Form */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Container
          className="p-5 rounded shadow-lg"
          style={{
            maxWidth: "400px",
            backgroundColor: "rgba(255, 255, 255, 0.39)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <motion.h1
            className="text-center"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            style={{
              animation: "colorChange 5s infinite",
              fontSize: "70px",
            }}
          >
            YaaSaai
          </motion.h1>
          <style>
            {`
              @keyframes colorChange {
                0% { color:rgb(96, 6, 6); }
                25% { color:darkgreen; }
                50% { color:rgb(16, 16, 123); }
                75% { color:rgb(126, 13, 126); }
                100% { color:coral }
              }
            `}
          </style>
          <motion.div
            style={{
              textAlign: "center",
              fontSize: "13px",
              marginTop: "10px",
              fontWeight: "bold",
              color: "white",
              WebkitTextStroke: "0.1px coral",
              textShadow:
                "1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000, -1px -1px 0 #000",
            }}
          >
            यासाई है तो ...सब्जियां यहीं हैं !
          </motion.div>

          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleLogin}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="Label">Enter Mobile No</Form.Label>
              <Form.Control
                type="text"
                placeholder="9090909090"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Button
              variant="success"
              className="w-100 mt-2"
              onClick={handleSendOtp}
            >
              Login with OTP
            </Button>

            {/*  <Button
              variant="success"
              onClick={handleGuestLogin}
              className="w-100 mt-2"
            >
              Continue as Guest
            </Button> */}
          </Form>

          {otpSent && (
            <Form onSubmit={handleVerifyOtp}>
              <Form.Group controlId="otpInput" className="mt-3">
                <Form.Label>Enter OTP</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter the OTP sent to your mobile"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
              </Form.Group>
              <Button variant="info" type="submit" className="w-100 mt-2">
                Verify OTP
              </Button>
            </Form>
          )}

          <div class="slogan">Grap to next move....!</div>
          <div
            className="text-center mt-3"
            style={{ fontSize: "12px", fontWeight: "bold" }}
          >
            By logging in, you agree to Yaasai's Terms of Use and Privacy
            Policy.
          </div>
        </Container>
        {/* <div className="d-flex justify-content-center mt-3">
          <Button
            variant="outline-info"
            size="sm"
            onClick={() => setShowReturnPolicy(true)}
            className="return_terms_button"
          >
            Return Policy
          </Button>
          <Button
            variant="outline-info"
            size="sm"
            onClick={() => setShowTermsPolicy(true)}
            className="return_terms_button"
          >
            Privacy Policy
          </Button>
        </div> */}

        <div className="d-flex justify-content-center mt-3">
          <a
            href="/return-policy.html" // or full URL like "https://yaasaai.com/return-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-info mx-2 text-decoration-underline"
          >
            Return Policy
          </a>
          <a
            href="/privacy-policy.html" // or full URL like "https://yaasaai.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-info mx-2 text-decoration-underline"
          >
            Privacy Policy
          </a>
        </div>

        <div className="d-flex justify-content-center mt-3">
          <Button
            variant="outline-info"
            size="sm"
            onClick={handleShow}
            className="return_terms_button"
          >
            Own Mission Of Yaasaai
          </Button>
        </div>
      </motion.div>
      {/* modal of mission of yaasaai */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="yaasaai-modal"
      >
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title className="justify-content-center ">
            Mission of Yaasaai
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center yaasaai-modal-body d-flex justify-content-center align-items-center">
          <img
            src={missionimage} // Update this path as needed
            alt="Yaasaai Mission"
            className="yaasaai-image"
          />
        </Modal.Body>
        <Modal.Footer className="justify-content-center modal-footer-custom">
          <Button variant="outline-danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ✅ Return Policy Modal */}
      <Modal
        show={showReturnPolicy}
        onHide={() => setShowReturnPolicy(false)}
        centered
        size="lg"
        scrollable
      >
        <Modal.Header closeButton>
          <h4 style={{ color: "#e74c3c", fontWeight: "bold" }}>
            📦 Return & Refund Policy
          </h4>
        </Modal.Header>

        <Modal.Body
          style={{ fontSize: "15px", lineHeight: "1.7", color: "#333" }}
        >
          <div style={{ padding: "10px 15px" }}>
            <p>
              Thank you for shopping at <strong>Yaasaai.com</strong>! Your
              satisfaction is our priority.
            </p>

            <h5 style={{ marginTop: "20px", color: "#2c3e50" }}>🧾 Returns</h5>
            <ul>
              <li>
                🕒 Return within <strong>1 calendar day</strong> from the
                delivery date.
              </li>
              <li>
                📦 Item must be <strong>unused</strong> and in original
                condition.
              </li>
              <li>🎁 Original packaging is required.</li>
              <li>
                🧾 Must have a <strong>receipt or proof of purchase</strong>.
              </li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#2c3e50" }}>💳 Refunds</h5>
            <ul>
              <li>🔍 We inspect your return upon receipt.</li>
              <li>
                ✅ If approved, refund will be initiated to your original
                payment method.
              </li>
              <li>⏳ Time to reflect depends on your bank's policy.</li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#2c3e50" }}>🚚 Shipping</h5>
            <ul>
              <li>
                📦 Return shipping cost is the{" "}
                <strong>customer’s responsibility</strong>.
              </li>
              <li>
                💸 Shipping charges are <strong>non-refundable</strong>.
              </li>
              <li>
                ➖ Refund will be adjusted after deducting return shipping
                costs.
              </li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#2c3e50" }}>
              ❌ Non-returnable Items
            </h5>
            <p>
              ⚠️ Certain perishable or special items may not be eligible for
              return or refund.
            </p>

            <h5 style={{ marginTop: "20px", color: "#2c3e50" }}>
              📞 Contact Us
            </h5>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:yaasaaitonk.com">yaasaaitonk@gmail.com</a>
            </p>
            <p>
              <strong>Phone:</strong>{" "}
              <a href="tel:+917014496283">+91 7014496283</a>
            </p>
            <p>
              <strong>Address:</strong> Kamdhenu Circle, Near FirstCry Mart,
              Captain Colony Chawani Tonk, Rajasthan 304001
            </p>

            <hr style={{ margin: "30px 0", borderTop: "1px dashed #ccc" }} />

            <h4 style={{ color: "#27ae60", fontWeight: "bold" }}>
              📋 रिटर्न और रिफंड नीति
            </h4>
            <p>
              <strong>ध्यान दें:</strong> बेचे गए उत्पाद वापस या बदले नहीं
              जाएंगे। केवल क्षतिग्रस्त या एक्सपायर्ड उत्पादों को उचित जांच के
              बाद बदला जाएगा।
            </p>

            <h5 style={{ marginTop: "20px", color: "#34495e" }}>📦 वापसी</h5>
            <ul>
              <li>
                📅 प्राप्ति के <strong>1 दिन</strong> के भीतर प्रोडक्ट वापस
                करें।
              </li>
              <li>🚫 बिना उपयोग के और समान स्थिति में हो।</li>
              <li>
                📦 <strong>मूल पैकेजिंग</strong> में होना चाहिए।
              </li>
              <li>🧾 रसीद या खरीद प्रमाण आवश्यक है।</li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#34495e" }}>💳 रिफंड</h5>
            <ul>
              <li>🔍 निरीक्षण के बाद रिफंड की स्थिति बताई जाएगी।</li>
              <li>
                ✅ स्वीकृति पर <strong>मूल भुगतान</strong> विधि पर रिफंड होगा।
              </li>
              <li>⏳ समय बैंक की नीति पर निर्भर करता है।</li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#34495e" }}>🚚 शिपिंग</h5>
            <ul>
              <li>💰 रिटर्न शिपिंग का खर्च ग्राहक को वहन करना होगा।</li>
              <li>🚫 शिपिंग शुल्क वापस नहीं किया जाएगा।</li>
              <li>📉 रिफंड में से यह शुल्क घटाया जाएगा।</li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#34495e" }}>
              ❌ गैर-वापसी योग्य वस्तुएं
            </h5>
            <p>⚠️ कुछ आइटम वापस नहीं किए जा सकते हैं।</p>

            <h5 style={{ marginTop: "20px", color: "#34495e" }}>
              📞 हमसे संपर्क करें
            </h5>
            <p>
              <strong>ईमेल:</strong>{" "}
              <a href="mailto:yaasaaitonk@gmail.com">yaasaaitonk@gmail.com</a>
            </p>
            <p>
              <strong>फोन:</strong>{" "}
              <a href="tel:+917014496283">+91 7014496283</a>
            </p>
            <p>
              <strong>पता:</strong> कमधेनु चौराहा, फर्स्ट क्राई मार्ट के पास,
              कैप्टन कॉलोनी छावनी टोंक, राजस्थान 304001
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowReturnPolicy(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Terms & Services Modal */}
      <Modal
        show={showTermsPolicy}
        onHide={() => setShowTermsPolicy(false)}
        centered
        size="lg"
        scrollable
      >
        <Modal.Header closeButton>
          <h4 style={{ fontWeight: "bold", color: "#007bff", margin: 0 }}>
            📄 Privacy Policy
          </h4>
        </Modal.Header>

        <Modal.Body
          style={{
            fontSize: "0.85rem",
            lineHeight: "1.6",
            overflowY: "auto", // enable vertical scroll
            paddingRight: "1rem",
          }}
        >
          <p className="contents">
            <strong>
              Welcome to <span style={{ color: "#28a745" }}>Yaasaai.com</span>
            </strong>
            . By accessing or using our website, you agree to be bound by the
            following terms and policies.
          </p>

          <p className="contents">
            We understand that privacy online is important to users of our site,
            especially when conducting business. This statement governs our
            privacy policies for both "Visitors" who browse the site and
            "Authorized Customers" who register and use our services.
          </p>

          <p className="contents">
            By using our Service, you agree to the collection and use of your
            information as outlined below. We use your data only to provide and
            improve the service — we do not share it beyond the scope of this
            policy.
          </p>
          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🔒 Privacy Policy: Permissions Usage
          </h5>
          <p className="contents">
            📍 Location Permission 👉 Why We Request Location Access:
            <ul
              style={{
                paddingLeft: "20px",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#555",
              }}
            >
              <li>
                📦 Provide accurate delivery service to your current or chosen
                address.
              </li>
              <li>
                🚚 Show you real-time tracking of your orders and the delivery
                person's location.
              </li>
              <li>
                🏬 Recommend nearby shops or services based on your location.
              </li>
            </ul>
            🔔 Notification Permission 👉 Why We Request Notification Access:
            <ul
              style={{
                paddingLeft: "20px",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#555",
              }}
            >
              <li>
                📬 Send important order updates, such as order confirmation,
                delivery status, and ETA.
              </li>
              <li>💰 Notify you of exclusive deals, offers, or discounts.</li>
              <li>
                🚨 Alert you about important service announcements (e.g.,
                delays, outages).
              </li>
            </ul>
            🔐 Your Privacy Matters :We do not collect or store personal data
            unnecessarily. All permissions are voluntary and used strictly for
            improving your experience. You may deny or revoke permissions
            anytime via your device settings, but some features may not function
            correctly without them.
          </p>
          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            📋 Information Collection and Use
          </h5>
          <p className="contents">
            We may request personal details such as your name, phone number, and
            address to help us provide better service. Your data is safe with
            us.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            📑 Log Data
          </h5>
          <p className="contents">
            Like many sites, we collect log data including IP address, browser
            version, pages visited, and timestamps. This helps us analyze and
            improve our performance.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🍪 Cookies
          </h5>
          <p className="contents">
            Cookies help personalize your experience. You can choose to accept
            or refuse them. Some features may not work properly if cookies are
            disabled.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🤝 Service Providers
          </h5>
          <p className="contents">We may engage third-party providers to:</p>
          <ul
            style={{
              paddingLeft: "20px",
              fontSize: "15px",

              color: "#555",
            }}
          >
            <li>Facilitate our Service</li>
            <li>Provide the Service on our behalf</li>
            <li>Perform Service-related tasks</li>
            <li>Analyze usage of the Service</li>
          </ul>
          <p className="contents">
            These providers access your information only to fulfill their tasks
            and are obligated to maintain confidentiality.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🔐 Security
          </h5>
          <p className="contents">
            We take data security seriously and use industry-standard methods to
            protect your personal information. However, no method is 100%
            secure.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🔗 Links to Other Sites
          </h5>
          <p className="contents">
            Our site may link to external websites. We are not responsible for
            their content or privacy practices. Please review their policies
            separately.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            👶 Children’s Privacy
          </h5>
          <p className="contents">
            We do not knowingly collect personal data from users under 18. If
            you believe your child has provided us with information, please
            contact us for immediate removal.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🔄 Changes to This Policy
          </h5>
          <p className="contents">
            This Privacy Policy may be updated occasionally. We advise you to
            review this page regularly. Any changes take effect immediately
            after posting.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTermsPolicy(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default LoginPage;
